export default "__VITE_ASSET__D6vG27YB__"